export const HistoryRecordCategories = Object.freeze({
    Others: 0,
    Treatment: 1,
    MedicalMeet: 2,
    Exam: 3
  });